import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  trend, 
  trendValue, 
  color = 'primary',
  onClick 
}) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary border-primary/20',
    success: 'bg-success/10 text-success border-success/20',
    warning: 'bg-warning/10 text-warning border-warning/20',
    accent: 'bg-accent/10 text-accent border-accent/20'
  };

  const trendColors = {
    up: 'text-success',
    down: 'text-destructive',
    neutral: 'text-text-secondary'
  };

  return (
    <div 
      className={`bg-card border border-border rounded-lg p-6 spring-transition hover:shadow-elevation-2 ${
        onClick ? 'cursor-pointer hover:border-primary/30' : ''
      }`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-text-secondary mb-1">{title}</p>
          <p className="text-3xl font-semibold text-text-primary mb-2">{value}</p>
          {subtitle && (
            <p className="text-sm text-text-secondary">{subtitle}</p>
          )}
          {trend && trendValue && (
            <div className="flex items-center mt-2">
              <Icon 
                name={trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus'} 
                size={16} 
                className={`mr-1 ${trendColors?.[trend]}`}
              />
              <span className={`text-sm font-medium ${trendColors?.[trend]}`}>
                {trendValue}
              </span>
              <span className="text-sm text-text-secondary ml-1">vs last week</span>
            </div>
          )}
        </div>
        <div className={`p-3 rounded-lg ${colorClasses?.[color]}`}>
          <Icon name={icon} size={24} />
        </div>
      </div>
    </div>
  );
};

export default StatCard;